import CurrencyInput, {CurrencyInputProps} from 'react-currency-input-field'

interface InputCurrencyProps extends CurrencyInputProps {}

export const InputCurrency = ({
  intlConfig = {locale: 'es-CO', currency: 'COP'},
  className = 'form-control',
  ...props
}: InputCurrencyProps) => {
  return (
    <CurrencyInput
      intlConfig={intlConfig}
      {...props}
      className={className}
      decimalsLimit={0}
      decimalScale={0}
    />
  )
}
